import { selectConvertedReadings, selectSelectedTestStations } from "./selectors";
import { _addTestStation, _filterTestStations, _removeTestStation, getTimeuuid } from "./util";

const NS_MAPS = 'CISVIEW_TESTSTATIONS_';



/** ************************************
 * MISC
 */

export const SET_TIMEUUID = `${NS_MAPS}SET_TIMEUUID`;
export const setTimeuuid = (timeuuid) => (dispatch) => {
	dispatch({ type : SET_TIMEUUID , payload: timeuuid });
}



/** ************************************
 * TEST STATIONS
 */

export const SET_TEST_STATIONS = `${NS_MAPS}SET_TEST_STATIONS`;
export const setTestStations = (testStations) => (dispatch) => {
	dispatch({ type : SET_TEST_STATIONS , payload: testStations });
}

export const setDefaultTestStations = () => (dispatch, getState) => {
	const convertedReadings = selectConvertedReadings(getState());
	const testStations = _filterTestStations(convertedReadings);
	dispatch(setTestStations(testStations));
};

export const CACHE_DEFAULT_TEST_STATIONS = `${NS_MAPS}CACHE_DEFAULT_TEST_STATIONS`;
export const cacheDefaultTestStations = () => (dispatch, getState) => {
	const convertedReadings = selectConvertedReadings(getState());
	const testStations = _filterTestStations(convertedReadings);
	dispatch({ type : CACHE_DEFAULT_TEST_STATIONS , payload: testStations });
}

export const CACHE_SERVER_TEST_STATIONS = `${NS_MAPS}CACHE_SERVER_TEST_STATIONS`;
export const cacheServerTestStations = (testStations) => (dispatch) => {
	dispatch({ type : CACHE_SERVER_TEST_STATIONS , payload: testStations });
}

export const addTestStation = (reading) => (dispatch, getState) => {
	const testStations = selectSelectedTestStations(getState())
	dispatch(setTestStations(_addTestStation(testStations, reading)))
}

export const removeTestStation = (reading) => (dispatch, getState) => {
	const testStations = selectSelectedTestStations(getState())
	dispatch(setTestStations(_removeTestStation(testStations, reading)))
}



/** ************************************
 * HTTP FLAGS
 */

export const SET_IS_LOADING = `${NS_MAPS}SET_IS_LOADING`;
export const setIsLoading = (isLoading) => (dispatch) => {
	dispatch({ type : SET_IS_LOADING , payload: isLoading });
}

export const SET_IS_LOADED = `${NS_MAPS}SET_IS_LOADED`;
export const setIsLoaded = (isLoaded) => (dispatch) => {
	dispatch({ type : SET_IS_LOADED , payload: isLoaded });
}

export const SET_IS_SAVING = `${NS_MAPS}SET_IS_SAVING`;
export const setIsSaving = (isSaving) => (dispatch) => {
	dispatch({ type : SET_IS_SAVING , payload: isSaving });
}


/** ************************************
 * ERROR MESSAGE
 */

export const SET_ERROR_MESSAGE = `${NS_MAPS}SET_ERROR_MESSAGE`;
export const setErrorMessage = (errorMessage) => (dispatch) => {
	dispatch({ type : SET_ERROR_MESSAGE , payload: errorMessage });
}

export const clearErrorMessage = () => (dispatch) => {
	dispatch(setErrorMessage());
}

/**
 * CLEAR
 */


export const clear = () => (dispatch) => {
	dispatch(setTestStations([]));
	dispatch(cacheDefaultTestStations([]));
	dispatch(cacheServerTestStations([]));
	dispatch(setIsLoading(false));
	dispatch(setIsLoaded(false));
	dispatch(setIsSaving(false));
	dispatch(clearErrorMessage());
	dispatch(setTimeuuid(getTimeuuid()));
}
